import { api } from "../../../utils/api";

export const patchDeleteAccountToPay = async (data) => {
  try {
    const response = await api.patch(`accountsPayable/delete`, data);
    console.log("estornando", response.data)
    return response.data;
  } catch (error) {
    throw error;
  }
};